// UIKit Components
import AlertModal from '../../ui-kit/components/AlertModal.vue'
import Backdrop from '../../ui-kit/components/Backdrop.vue'
import BrandBar from '../../ui-kit/components/BrandBar.vue'
import Button from '../../ui-kit/components/Button.vue'

import ContextMenu from '../../ui-kit/components/ContextMenu/ContextMenu'
import ContextMenuItem from '../../ui-kit/components/ContextMenu/ContextMenuItem'

import Checkbox from '../../ui-kit/components/Checkbox.vue'
import Grid from '../../ui-kit/components/Grid.vue'
import Header from '../../ui-kit/components/Header.vue'
import Icon from '../../ui-kit/components/Icon.vue'
import Input  from '../../ui-kit/components/Input.vue'
import Modal from '../../ui-kit/components/Modal.vue'
import Popover from '../../ui-kit/components/Popover.vue'

import Radio  from '../../ui-kit/components/Radio/Radio'
import RadioOption from '../../ui-kit/components/Radio/RadioOption'

import SwitchButton from '../../ui-kit/components/Switch.vue'
import Tab from '../../ui-kit/components/Tab.vue'
import Tabs from '../../ui-kit/components/Tabs.vue'
import Textarea from '../../ui-kit/components/Textarea.vue'
import Timepicker from '../../ui-kit/components/Timepicker.vue'
import Toast from '../../ui-kit/components/Toast.vue'

import BaseDropdown from '../../ui-kit/components/Dropdown/BaseDropdown'
import BaseDropdownOption from '../../ui-kit/components/Dropdown/BaseDropdownOption'
import MultipleDropdownOption from '../../ui-kit/components/Dropdown/MultipleDropdownOption'
import IconDropdownOption from '../../ui-kit/components/Dropdown/IconDropdownOption'
import UserDropdownOption from '../../ui-kit/components/Dropdown/UserDropdownOption'

const P4aComponents = function (Vue) {
  // p4a ui-kit components

  Vue.component('p4a-alertmodal', AlertModal)
  Vue.component('p4a-backdrop', Backdrop);
  Vue.component('p4a-brandbar', BrandBar);
  Vue.component('p4a-button', Button);

  Vue.component('p4a-context-menu', ContextMenu)
  Vue.component('p4a-context-menu-item', ContextMenuItem)

  Vue.component('p4a-checkbox', Checkbox);
  Vue.component('p4a-grid', Grid);
  Vue.component('p4a-header', Header);
  Vue.component('p4a-icon', Icon);
  Vue.component('p4a-input', Input);
  Vue.component('p4a-modal', Modal);
  Vue.component('p4a-popover', Popover);
  Vue.component('p4a-radio', Radio);
  Vue.component('p4a-radio-option', RadioOption);
  Vue.component('p4a-switch', SwitchButton);
  Vue.component('p4a-tab', Tab);
  Vue.component('p4a-tabs', Tabs);
  Vue.component('p4a-textarea', Textarea);
  Vue.component('p4a-timepicker', Timepicker);
  Vue.component('p4a-toast', Toast);

  Vue.component('p4a-dropdown', BaseDropdown);
  Vue.component('p4a-dropdown-option', BaseDropdownOption);
  Vue.component('p4a-multiple-dropdown-option', MultipleDropdownOption)
  Vue.component('p4a-icon-dropdown-option', IconDropdownOption)
  Vue.component('p4a-user-dropdown-option', UserDropdownOption)
};

export default P4aComponents



//////////////////
// WEBPACK FOOTER
// ./node_modules/pro4all-ui/plugins/componentLists/P4a-components.js
// module id = null
// module chunks = 